<div class="row">
  <div class="col pt-1">
    <div class="editorial-links">
      <div class="header-editorial-group" *ngFor="let group of menuItems">
        <p class="text-bold my-0" [class.mb-1]="!enableThumbnail" *ngIf="group?.title">{{ group.title }}</p>
        <shrd-uic-nav-button
          *ngFor="let link of group?.childList"
          class="nav-btn"
          [label]="link.title"
          [headlineText]="link.headline"
          [imgUrl]="enableThumbnail && link.thumbnail"
          [imgAlt]="link.title"
          [isTextIndent]="enableThumbnail"
          [isCompressed]="!enableThumbnail"
          [isImageCoverMode]="true"
          [url]="link.url"
          [shrdUtcTrackEvent]="{
            category: 'SiteOperations',
            action: 'MainNavigation',
            label: menuTitle + '|L2:' + link.title
          }"
        ></shrd-uic-nav-button>
      </div>
    </div>
  </div>
</div>
